require('./brokerGeneralView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter, Prompt } = require('react-router-dom');
const classNames = require('classnames');
const PropTypes = require('prop-types');

// @components
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
const MyWallet = require('components/myWallet/myWallet');
const {
  BrokerCustomWalletLoader,
} = require('customWallets/components/brokerCustomWalletLoader/brokerCustomWalletLoader');
const BrokerGeneralMoreOptionsButton = require('components/broker/brokerGeneralMoreOptionsButton/brokerGeneralMoreOptionsButton');
const { BrokerMyInvestments } = require('components/broker/myInvestments/brokerMyInvestments');
const BrokerNewsColumn = require('components/commons/broker/news/brokerNewsColumn');
const { StocksBanner } = require('components/broker/stocksBanner/stocksBanner');
const {
  BrokerAttentionPlanStartingModal,
} = require('components/broker/brokerStartingModal/brokerAttentionPlanStartingModal');
const {
  BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const BrokerFavoriteWidget = require('components/broker/brokerFavoriteWidget/brokerFavoriteWidget');
const { BrokerMarketsTrend } = require('components/broker/brokerMarketsTrend/brokerMarketsTrend');
const {
  BrokerMostPopularOfMonth,
} = require('components/broker/brokerMostPopularOfMonth/brokerMostPopularOfMonth');
const {
  BrokerTodaysMainStocks,
} = require('components/broker/brokerTodaysMainStocks/brokerTodaysMainStocks');
const {
  BrokerMarketsCalendar,
} = require('components/broker/brokerMarketsCalendar/brokerMarketsCalendar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const {
  RAGlobalPosition,
  RAPatrimonyDetails,
  RAFeatureFlagModal,
  RANonresidentialModal,
} = require('wealth-robo');
const BrokerWatchlistModal = require('components/broker/brokerWatchlistModal/brokerWatchlistModal');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const {
  CommercialAdsCCValidated: CommercialAds,
} = require('components/commons/commercialAds/commercialAds');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BrokerAlerts = require('components/commons/broker/alerts/brokerAlerts');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { RAOKCover } = require('wealth-robo'); // OKCover modified to include unused large banner scenario
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const {
  BrokerClientWarningModal,
} = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const { EmptyState } = require('commonsComponents/emptyState');
const OKModal = require('components/commons/OKModal/OKModal');
const {
  BrokerNoStockAccountModal,
} = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');
const BrokerInformativePopUp = require('components/broker/brokerInformativePopUp/brokerInformativePopUp');
const BrokerIABanner = require('components/broker/brokerIA/brokerIAComponents/brokerIABanner/brokerIABanner');
const BrokerIAInvestmentModule = require('components/broker/brokerIA/brokerIAComponents/brokerIAInvestmentModule/brokerIAInvestmentModule');
const { RATestExpirationDisclaimer } = require('wealth-robo');
const BrokerRoboExpirationMessage = require('components/broker/brokerRoboExpirationMessage/brokerRoboExpirationMessage');
const BrokerCryptoPGBanner = require('components/broker/brokerCryptoPGBanner/brokerCryptoPGBanner');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatWithoutRound, formatCurrency } = require('utilities/currencyHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const newsActions = require('actions/brokerNews');
const myWalletAction = require('actions/myWallet');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const brokerStocksByContractActions = require('actions/brokerWallets');
const BrokerAlertsActions = require('actions/brokerAlerts');
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerCorporatesOperations = require('actions/brokerCorporatesOperations');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const bannerActions = require('actions/bannerUpdate');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const BrokerCustomWalletInvestmentsActions = require('customWallets/actions/brokerCustomWalletInvestments');
const BrokerCustomWalletLoaderActions = require('customWallets/actions/brokerCustomWalletLoader');
const BrokerInternalTransferFundsActions = require('actions/brokerInternalTransferFunds');
const BrokerStocksSellActions = require('actions/brokerStocksSell');
const BrokerWatchlistActions = require('actions/brokerWatchlist');
const BrokerInformativePopUpActions = require('actions/brokerInformativePopUp');
const { raCheckStatusActions, raFeatureFlagActions } = require('wealth-robo');
const brokerContractState = require('actions/brokerContractState');
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');
const BrokerUsPersonBlockActions = require('actions/brokerUsPersonBlock');

// @utilites
const {
  recordLink,
  recordLinkV2,
  PROC_BROKER_PG_INTERACTION,
  PROC_INVESTMENT_MENU_INTERACCION,
  PROC_INVESTMENT_BROKER_ROBO,
  PROC_INVESTMENT_BROKER_PG,
  PROC_RA_GLOBAL_POSITION_PATRIMONY_DETAILS,
  PROC_RA_GLOBAL_POSITION_INTERACTION,
  PROC_RA_GLOBAL_POSITION_HEADER_HELP,
  PROC_INVESTMENT_BROKER_PG_NAME,
} = require('utilities/tagging');

// @constants
const {
  ACTIVE_TAB_CONTRACTS,
  BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB,
  BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB,
  MYPROFILE_BROKER_ERROR_URL,
  GRAPHIC_TUTOR_TYPE_7,
  BANNER_TYPE_ID_LOCAL,
  BANNER_UPDATE_ID_GENERAL_VIEW,
  BROKER_CUSTOM_WALLET_CONFIGURATION_URL,
  BROKER_LANDING_PG_PLACE,
  EURO_TEXT,
  BROKER_PG_URL,
  MYPROFILE_BROKER_EXPLORE_URL,
  TABLET_PRO_MIN_WIDTH,
  HIRE_VALUES_CONTRACT_URL,
} = require('constants/index');
const { MYPROFILE_BROKER_ROBO_URL, RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER } =
  require('wealth-robo').constants;
const {
  AGENDA,
  ALERTS,
  CALLMEBACK,
  CCV_HIRING_CHECK_DOCUMENT,
  INFO_POPUP_ROBOADVISOR,
  INFO_POPUP_YOU_INVEST,
  MORNINGSTAR_MOST_POPULAR,
  NEWS,
  NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES,
  PUT_YOUR_MONEY_TO_WORK,
  TREND,
  TYPE_FUNDS,
  TYPE_PLANS,
  TYPE_STOCKS,
  YOUR_INVESTMENTS,
} = require('constants/flagBasedFeatures');
const {
  COUNTRIES_CODES: { ES },
} = require('constants/countries');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { WEALTH_CRYPTO_PG_BANNER } from 'constants/flagBasedMBFeatures';

// @images
const watchlistIcon = require('assets/images/watchlistStar_icon.svg');

class BrokerGeneralView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialRender: true,
      nextLocation: null,
      showInformativePopUpModal: true,
      showNonResidentModal: false,
      showNonResidentModalForOpenSecurities: false,
      prevActiveTabValue: 0,
      showTickerModal: false,
      setProductStatus: false,
      openModalUsPerson: false,
      isBlockingRouteChange: false,
    };
    this.handlePatrimonyDetailsClick = this.handlePatrimonyDetailsClick.bind(this);
    this.handleTutorialClick = this.handleTutorialClick.bind(this);
    this.buildFavoriteWidget = this.buildFavoriteWidget.bind(this);
    this.onContractTabSelect = this.onContractTabSelect.bind(this);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleBrokerTabClick = this.handleBrokerTabClick.bind(this);
    this.handleRoboTabClick = this.handleRoboTabClick.bind(this);
    this.handleShowBanner = this.handleShowBanner.bind(this);
    this.handleStockContractClick = this.handleStockContractClick.bind(this);
    this.onHandleTogglNonResidentModal = this.onHandleTogglNonResidentModal.bind(this);
    this.toggleRightsInfo = this.toggleRightsInfo.bind(this);
    this.isFetchingMyInvestment = this.isFetchingMyInvestment.bind(this);
    this.errorReceivedMyInvestment = this.errorReceivedMyInvestment.bind(this);
    this.onSubmitNewList = this.onSubmitNewList.bind(this);
    this.onWatchlistModalToggle = this.onWatchlistModalToggle.bind(this);
    this.saveListName = this.saveListName.bind(this);
    this.cancelWatchlistModal = this.cancelWatchlistModal.bind(this);
    this.onWatchlistDetails = this.onWatchlistDetails.bind(this);
    this.onHandleToggleInformativePopUpModal = this.onHandleToggleInformativePopUpModal.bind(this);
  }

  //TODO:
  //Right now we invoke two different success actions, one brings the investments and
  //the other one the investments's description. This is why we set the outdate flag to true.
  //We need to find out if it is possible to unify and analyze if we need BE changes to do this.
  componentDidMount() {
    this.props.outdateMyInvestments();
    this.props.outdateCustomWalletInvestments();
    this.props.setPreoviousPage('');
    //first gets the portfolioList, then defaultViewId, whenever reach erros will
    //throw this callback action passed by parameter.
    this.props.getWalletData(this.props.getStocksByType);
    this.init();
    const immBrokerMyInvestments = this.getBrokerMyInvestments();
    if (immBrokerMyInvestments.get('fetchSuccess')) {
      this.setPageInteraction();
    }
    this.getPopUpsInformation();

    const { immBrokerUsPersonBlock, getIsUsPerson } = this.props;
    if (!immBrokerUsPersonBlock.get('fetchSuccess') && !immBrokerUsPersonBlock.get('isFetching')) {
      getIsUsPerson();
    }
  }

  componentDidUpdate(prevProps) {
    const { flagBasedFeatures, immMyWalletCharts } = this.props;
    const { setProductStatus } = this.state;
    const oldFlagsBasedFeatures = prevProps.flagBasedFeatures;
    const immPrevMyWalletCharts = prevProps.immMyWalletCharts;
    const immBrokerMyInvestments = this.getBrokerMyInvestments();
    this.setState({ initialRender: false });
    if (immBrokerMyInvestments.get('fetchSuccess') && !setProductStatus) {
      this.setPageInteraction();
    }
    const activeTab = immMyWalletCharts.get('activeTab');
    const activeTabChanged = immPrevMyWalletCharts.get('activeTab') !== activeTab;
    if (activeTab == ACTIVE_TAB_CONTRACTS && activeTabChanged) {
      this.onContractTabSelect(immPrevMyWalletCharts.get('activeTab'));
    }
    if (flagBasedFeatures.get('robo-enabled') && !oldFlagsBasedFeatures.get('robo-enabled')) {
      this.fetchRoboData();
    }

    if (activeTabChanged) {
      const tag = ['products', 'assets', 'contract'];
      taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'pgSliderMenu', tag[activeTab]);
    }
  }

  componentWillUnmount() {
    this.props.resetSelectedView();
    this.props.bannerHide();
  }

  getPopUpsInformation() {
    const { getPopUpsInfo, immBrokerInformativePopUp } = this.props;
    if (
      !immBrokerInformativePopUp.get('isFetching') &&
      !immBrokerInformativePopUp.get('fetchSuccess')
    ) {
      getPopUpsInfo();
    }
  }

  setPageInteraction() {
    const immBrokerMyInvestments = this.getBrokerMyInvestments();
    const products = immBrokerMyInvestments.get('products').toJS();
    let productStatus = 'empty';
    for (const product in products) {
      if (products[product].total > 0) {
        productStatus = 'active';
      }
    }
    this.setState({
      setProductStatus: true,
    });
    taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'productStatusActive', productStatus);
  }

  onContractTabSelect(value) {
    //We don't have contract tab so set previousSelected tab
    this.setState({
      prevActiveTabValue: value,
    });
  }

  onWalletLoaderPreferencesClick() {
    taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'pgPreferencesIcon');
  }

  init() {
    this.updateBanner();
    this.props.getIndexes();
    this.props.checkPersonalInformationData();
    if (this.props.flagBasedFeatures.get('watchlist-enabled')) {
      this.props.resetWatchlistDetails();
      this.props.getUserWatchlist();
      this.props.listSelectedForParam('');
    }
    if (this.props.flagBasedFeatures.get('robo-enabled')) {
      this.props.checkStatus();
      this.props.fetchFeatureFlag();
    }
    this.props.fetchFeatureFlag();
  }

  handlePatrimonyDetailsClick() {
    const {
      match: {
        params: { robo },
      },
    } = this.props;
    const categoryEvent = !!robo ? PROC_RA_GLOBAL_POSITION_INTERACTION : PROC_BROKER_PG_INTERACTION;
    recordLink(categoryEvent, PROC_RA_GLOBAL_POSITION_PATRIMONY_DETAILS);
  }

  handleTutorialClick() {
    const {
      match: {
        params: { robo },
      },
    } = this.props;
    const categoryEvent = !!robo ? PROC_RA_GLOBAL_POSITION_INTERACTION : PROC_BROKER_PG_INTERACTION;
    recordLink(categoryEvent, PROC_RA_GLOBAL_POSITION_HEADER_HELP);
  }

  handleDerechosInfoText() {
    const immBrokerMyInvestments = this.props.brokerMyInvestments;
    const hasAssociatedRights = immBrokerMyInvestments.get('isRightsAssociated');

    if (hasAssociatedRights) {
      this.props.toggleDerechosInfo(true);
    }
  }

  handleBrokerTabClick() {
    recordLink(PROC_INVESTMENT_MENU_INTERACCION, PROC_INVESTMENT_BROKER_PG);
    this.props.history.push(BROKER_PG_URL);
  }

  handleRoboTabClick() {
    recordLink(PROC_INVESTMENT_MENU_INTERACCION, PROC_INVESTMENT_BROKER_ROBO);
    this.handleDerechosInfoText();
    this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
  }

  getBrokerMyInvestments() {
    const isGeneral = this.props.immMyWalletCharts.get('isGeneralViewSelected');
    const immBrokerMyInvestments = isGeneral
      ? this.props.brokerMyInvestments
      : this.props.immBrokerCustomWalletInvestments;
    return immBrokerMyInvestments;
  }

  onHandleTogglNonResidentModal() {
    this.setState({
      showNonResidentModal: !this.state.showNonResidentModal,
    });
  }

  onHandleToggleInformativePopUpModal() {
    this.setState({
      showInformativePopUpModal: !this.state.showInformativePopUpModal,
    });
  }

  toggleRightsInfo() {
    this.props.toggleDerechosInfo(false);
  }

  handleAdClick() {
    return false;
  }

  handleRetry() {
    this.props.getWalletData(this.props.getStocksByType);
  }

  handleShowBanner() {
    this.props.bannerShow();
  }

  handleOpenMyWalletToggle(onToggleFunction) {
    const calculationData = {
      categoriaEvento: 'myPortfolioHomeInteraction',
      accionEvento: 'myPortfolioCard',
      etiquetaEvento: 'dataCalculation',
    };
    recordLinkV2(calculationData);
    onToggleFunction();
  }

  handleStockContractClick(nextLink) {
    const {
      immbrokerClientWarningModal,
      showClientWarningModal,
      immStocksContracts,
      showNoStockAccountModal,
      history,
    } = this.props;
    // Starts listening for redirections
    const hasNoStockContracts = immStocksContracts.isEmpty();
    const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
    const isFetching = immbrokerClientWarningModal.get('isFetching');
    const isFetched = immbrokerClientWarningModal.get('isFetched');
    if (isFetched && !isFetching) {
      if (!clientPersonalInfoUpdated) {
        showClientWarningModal(history);
        this.setState({
          nextLocation: nextLink,
          isBlockingRouteChange: true,
        });
      } else if (hasNoStockContracts) {
        showNoStockAccountModal();
      } else {
        history.push(nextLink);
      }
    } else if (!isFetched && !isFetching) {
      history.push(MYPROFILE_BROKER_ERROR_URL);
    }

    window.modalInstance = this;
  }

  updateBanner() {
    const config = (
      <OKLink modifier="complementary" to={BROKER_CUSTOM_WALLET_CONFIGURATION_URL}>
        <FormattedText
          className="broker-banner__description--link"
          value="brokerCustomWalletBanner-secondDescriptionCustomWalletConfig"
        />
      </OKLink>
    );

    const data = {
      title: formatText('brokerCustomWalletBanner-titleCustomWallet'),
      description: [
        {
          value: 'brokerCustomWalletBanner-firstDescriptionCustomWallet',
        },
        {
          value: 'brokerCustomWalletBanner-secondDescriptionCustomWallet',
          injected: [config],
        },
      ],
      optionsBannerType: {
        text: formatText('brokerCustomWalletBanner-linkNameCustomWallet'),
        modifier: 'link',
      },
    };
    const type = BANNER_TYPE_ID_LOCAL;
    const id = BANNER_UPDATE_ID_GENERAL_VIEW;
    this.props.bannerUpdateData(id, type, data);
  }

  generateKnowTheseStocksSection() {
    const redirectButton = (
      <OKButton
        modifier="secondary"
        to={formatText('broker-generalKnowTheseStocksUrl')}
        size="small"
        onClick={() => taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'seeMoreBannerButton')}
      >
        {formatText('broker-seeMore')}
      </OKButton>
    );
    return (
      <FeatureTogglingRender notAllowedProductKey={TYPE_STOCKS}>
        <ContentBox
          title={formatText('broker-generalKnowTheseStocksTitle')}
          customClassName="broker-general-view__know-these-stocks"
          rightContent={redirectButton}
        >
          <FormattedText
            className="broker-general-view__know-these-stocks-content"
            value="broker-generalKnowTheseStocksContent"
          />
        </ContentBox>
      </FeatureTogglingRender>
    );
  }

  openWatchlistModal() {
    this.onWatchlistModalToggle();
    this.handleWatchlistModal();
  }

  buildComponentAd() {
    let buttonProps = {
      onClick: () => this.openWatchlistModal(),
      inverse: true,
      modifier: 'secondary',
    };

    return (
      <div className={`broker-general-view__watchlist-ad`}>
        <div className="broker-general-view__watchlist-ad-wrapper">
          <img src={watchlistIcon} className="broker-general-view__watchlist-ad-icon" />
          <p className="broker-general-view__watchlist-ad-title">
            <FormattedText value={'brokerWatchList-brokerWatchlist_emptyStateTitle'} />
          </p>
          <p className="broker-general-view__watchlist-ad-description">
            <FormattedText value={'brokerWatchList-brokerWatchlist_emptyStateDesciption'} />
          </p>
          <OKButton {...buttonProps}>
            <FormattedText value={'brokerWatchList-brokerWatchlist_watchListAdButton'} />
          </OKButton>
        </div>
      </div>
    );
  }

  buildWatchlistWidgetEmptyState() {
    return <React.Fragment>{this.buildComponentAd()}</React.Fragment>;
  }

  buildFavoriteWidget() {
    const { immFavoriteContent, listSelectedForParam } = this.props;
    const isFetching = immFavoriteContent.get('isFetchinglist');
    const isFetchinglistError = immFavoriteContent.get('isFetchinglistError');
    const favoriteContent = immFavoriteContent.get('watchlistContent');
    const listName = immFavoriteContent.get('listName');
    const newWatchlistAdded = immFavoriteContent.get('newWatchlistAdded');
    let favoriteWidget;

    if (isFetchinglistError && !isFetching) {
      favoriteWidget = (
        <ContentBox id="broker-watchlist-section" modifier="complementary" product="wealth">
          <EmptyState primaryText={'empty state text'} iconType="noitems-wealth" />
        </ContentBox>
      );
    } else if (favoriteContent.size === 0) {
      favoriteWidget = this.buildWatchlistWidgetEmptyState();
    } else {
      favoriteWidget = (
        <BrokerFavoriteWidget
          emptyStateLink={MYPROFILE_BROKER_EXPLORE_URL}
          footerLinkText={formatText('brokerFavoriteWidget-brokerFavoriteWidget_link')}
          favoriteContent={favoriteContent}
          watchlistModalToggle={this.onWatchlistModalToggle}
          listName={listName}
          showWatchlistDetails={this.onWatchlistDetails}
          newWatchlistAdded={newWatchlistAdded}
          listSelectedForParam={listSelectedForParam}
        />
      );
    }

    return (
      <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation broker-general-view-investment-specialist">
        {favoriteWidget}
      </div>
    );
  }

  isFetchingMyInvestment() {
    return (
      this.props.brokerMyInvestments.get('isFetching') ||
      this.props.immBrokerCustomWalletInvestments.get('isFetching') ||
      this.props.immMyWalletCharts.get('isFetching') ||
      this.props.immMyWalletCharts.getIn(['defaultView', 'isFetching']) ||
      this.props.immBrokerCustomWalletPortfolios.getIn('isFetching')
    );
  }

  errorReceivedMyInvestment() {
    const isGeneralViewCWSelected = this.props.immMyWalletCharts.get('isGeneralViewSelected');
    if (isGeneralViewCWSelected) {
      return this.props.brokerMyInvestments.get('errorReceived');
    }
    return (
      this.props.brokerMyInvestments.get('errorReceived') ||
      this.props.immBrokerCustomWalletInvestments.get('errorReceived')
    );
  }

  defaultTab = flagBasedFeatures => {
    if (flagBasedFeatures.get(TYPE_FUNDS) && !flagBasedFeatures.get(TYPE_PLANS)) {
      return BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB;
    } else if (!flagBasedFeatures.get(TYPE_FUNDS) && flagBasedFeatures.get(TYPE_PLANS)) {
      return BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB;
    }
  };

  deactivateTabsMode = flagBasedFeatures => {
    return [flagBasedFeatures.get(TYPE_FUNDS), flagBasedFeatures.get(TYPE_PLANS)].some(
      flag => !flag
    );
  };

  buildRoboErrorState() {
    const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
    const retryButton = (
      <OKButton onClick={this.handleRetry}>
        <FormattedText value="broker-retry" />
      </OKButton>
    );
    return (
      <ContentBox customClassName="broker-general-view__robo-error">
        <EmptyState
          button={retryButton}
          primaryText={lostConnectionFirstLine}
          iconType="nointernet-wealth"
        />
      </ContentBox>
    );
  }

  buildBrokerBody(
    immBrokerMyInvestments,
    isFetchingMyInvestment,
    brokerMyInvestmentsErrorReceived,
    totalPlans
  ) {
    const {
      flagBasedFeatures,
      flagBasedMBFeatures,
      onToggleEvolutionModal,
      brokerWalletsState,
      brokerAlerts,
      immAccounts,
      getContractState,
      onStartConvenienceMiFIDTest,
      immBrokerUsPersonBlock,
      immProfile,
      match: {
        params: { robo },
      },
    } = this.props;

    const myWalletCharts = this.props.immMyWalletCharts;
    const isUsPerson = immBrokerUsPersonBlock.get('isUsPerson');
    const immStocksByType = immBrokerMyInvestments.get('products');
    const immFundsContributionsList = immBrokerMyInvestments.get('fundsContributionsList');
    const immStocksByContract = brokerWalletsState.get('walletList');
    const fetchingCustomWallet =
      myWalletCharts.get('isFetching') || myWalletCharts.getIn(['defaultView', 'isFetching']);
    const fetchingStocksByContract =
      brokerWalletsState.get('isFetchingProducts') || fetchingCustomWallet;
    const fetchingStocksByType = immBrokerMyInvestments.get('isFetching') || fetchingCustomWallet;
    const newsSourceText = formatText('broker-newsSourceText');
    const knowTheseStocksRedirectSection = this.generateKnowTheseStocksSection();
    const activeTab = this.props.immMyWalletCharts.get('activeTab');
    const watchlistEnabled = flagBasedFeatures.get('watchlist-enabled');
    const brokerFavoriteWidget = watchlistEnabled ? this.buildFavoriteWidget() : null;
    const showRightsInfo = immBrokerMyInvestments.get('isderechosInfoShown');
    const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const buySellBtnText = formatText('broker-buySellBtnText');
    const searchButtonText = formatText('broker-broker_searchProducts');
    const isRoboActive = !!robo;
    const brokerIAFlag = flagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
    const brokerIAEnabled =
      !!brokerIAFlag && !brokerIAFlag.includes(immProfile.get('originCountry'));
    const callMeBackEnabled = flagBasedFeatures.get(CALLMEBACK);
    const investmentSpecialistAndOthers = (
      <React.Fragment>
        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation broker-general-view-investment-specialist">
          <BrokerInvestmentSpecialist />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
          {brokerIAEnabled ? (
            <BrokerIABanner
              titleKey="brokerIA-brokerIA"
              subtitleKey="brokerIA-detail_slide"
              type="pgo-exo"
              callMeBackEnabled={callMeBackEnabled}
            />
          ) : (
            <FeatureTogglingRender notAllowedProductKey={ALERTS}>
              <BrokerAlerts
                brokerAlerts={brokerAlerts}
                getAlerts={this.props.getAlerts}
                onClickAlertsTooltip={() =>
                  taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'alertsTooltip')
                }
              />
            </FeatureTogglingRender>
          )}
        </div>
      </React.Fragment>
    );
    const newsSourceTextElement = (
      <div className="col-xs-12 grid-view--fix-cell-separation">{newsSourceText}</div>
    );

    const brokerInvestMentTab = (
      <BrokerMyInvestments
        immAccounts={immAccounts}
        immBrokerMyInvestments={immBrokerMyInvestments}
        brokerMyInvestmentsErrorReceived={brokerMyInvestmentsErrorReceived}
        isFetchingMyInvestment={isFetchingMyInvestment}
        immStocksByType={immStocksByType}
        immFundsContributionsList={immFundsContributionsList}
        immStocksByContract={immStocksByContract}
        isFetchingStocksByType={fetchingStocksByType}
        isFetchingStocksByContract={fetchingStocksByContract}
        getStocksContracts={this.props.getStocksContracts}
        getStocksByContract={this.props.getStocksByContract}
        postWalletAlias={this.props.postWalletAlias}
        setOperationContractValue={this.props.setOperationContractValue}
        onInternalTransferFundsClick={this.props.onInternalTransferFundsClick}
        onOpenTraderClick={this.props.onOpenTraderClick}
        setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
        setOrdersAndMovementsContract={this.props.setOrdersAndMovementsContract}
        immMyWalletCharts={this.props.immMyWalletCharts}
        onHandleBuyClick={this.handleStockContractClick}
        onPreSelectOriginInternalTransferFund={this.props.onPreSelectOriginInternalTransferFund}
        setSellContract={this.props.setSellContract}
        onHandleRetry={this.handleRetry}
        getContractState={getContractState}
        pageName={PROC_INVESTMENT_BROKER_PG_NAME}
      />
    );

    let moreOptions;
    let actionLinkButton;
    if (!isRoboActive) {
      moreOptions = (
        <div className="broker-general-view__action-link-btn col-sm-4">
          <BrokerGeneralMoreOptionsButton
            onStartConvenienceMiFIDTest={onStartConvenienceMiFIDTest}
            funds={immFunds}
            plans={totalPlans}
            onOpenTraderClick={this.props.onOpenTraderClick}
            onHandleStockContractClick={this.handleStockContractClick}
            textButton="accounts-accounts_options"
            inverse={false}
            onOpenHireClick={this.handleOpenHireClick}
            isUsPerson={isUsPerson}
            openModal={() => this.setState({ openModalUsPerson: true })}
          />
        </div>
      );
      actionLinkButton = (
        <div className="broker-general-view__action-link-btn col-sm-3">
          <OKButton
            modifier="primary"
            to={MYPROFILE_BROKER_EXPLORE_URL}
            onClick={() => taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'pgBuyButton')}
          >
            {buySellBtnText}
          </OKButton>
        </div>
      );
    }

    const searchButton = (
      <div className="broker-general-view__action-link-btn col-sm-5">
        <OKButton
          modifier="secondary"
          leftIcon="icon-s-buscar"
          onClick={() => {
            const searchButtonData = {
              etiquetaEvento: 'myPorfolio',
              categoriaEvento: 'buscador/simple',
            };
            recordLinkV2(searchButtonData);
            return this.props.handleShowSearchWidget();
          }}
        >
          {searchButtonText}
        </OKButton>
      </div>
    );

    const ffPutYourMoneyToWork = flagBasedFeatures.get(PUT_YOUR_MONEY_TO_WORK);
    const ffCryptoPgBanner = flagBasedMBFeatures.get(
      WEALTH_CRYPTO_PG_BANNER
    );

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <BrokerCustomWalletLoader
              handledPreferencesClick={this.onWalletLoaderPreferencesClick}
            />
          </div>
          <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
            {searchButton}
            {moreOptions}
            {actionLinkButton}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <div className="row">
              <div className="col-md-12 grid-view--fix-cell-separation">
                <MyWallet
                  immBrokerCustomWalletPortfolios={this.props.immBrokerCustomWalletPortfolios}
                  immBrokerMyInvestments={immBrokerMyInvestments}
                  immMyWalletCharts={this.props.immMyWalletCharts}
                  immStocksByType={immStocksByType}
                  getEvolutionData={this.props.getEvolutionData}
                  onHandleRetry={this.handleRetry}
                  onToggleModal={() => this.handleOpenMyWalletToggle(this.props.onToggleModal)}
                  activeTab={activeTab}
                  onToggleEvolutionModal={onToggleEvolutionModal}
                  brokerMyInvestmentsErrorReceived={brokerMyInvestmentsErrorReceived}
                  isFetchingMyInvestment={isFetchingMyInvestment}
                  showRightsInfo={showRightsInfo}
                  toggleRightsInfo={this.toggleRightsInfo}
                  prevActiveTabValue={this.state.prevActiveTabValue}
                  pageName={PROC_INVESTMENT_BROKER_PG_NAME}
                  flagBasedFeatures={flagBasedFeatures}
                />
              </div>
              {ffCryptoPgBanner && (
                <div className="col-md-12 grid-view--fix-cell-separation">
                  <BrokerCryptoPGBanner />
                </div>
              )}
              {ffPutYourMoneyToWork && (
                <div className="col-md-12 grid-view--fix-cell-separation">
                  <CommercialAds
                    path="broker/general"
                    type="banner-c"
                    extraClass="broker-general-view__first-ad"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xs-12 col-md-4">
            <div className="row">
              {brokerFavoriteWidget}
              {!watchlistEnabled && investmentSpecialistAndOthers}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 grid-view--fix-cell-separation">{brokerInvestMentTab}</div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <div className="row">
              {brokerIAEnabled && (
                <div className="col-md-12 grid-view--fix-cell-separation">
                  <BrokerIAInvestmentModule shouldRequestPGInfo={false} compact={true} />
                </div>
              )}
              <FeatureTogglingRender notAllowedProductKey={TYPE_STOCKS} productKeyFilter="every">
                <div className="col-md-12 grid-view--fix-cell-separation">
                  <BrokerTodaysMainStocks
                    onHandleBuyClick={(nextLink, productName) => {
                      taggingEventHandled(
                        PROC_INVESTMENT_BROKER_PG_NAME,
                        'todayProtagonistsBuyButton',
                        productName
                      );
                      this.handleStockContractClick(nextLink);
                    }}
                    pageName={PROC_INVESTMENT_BROKER_PG_NAME}
                  />
                </div>
              </FeatureTogglingRender>
              <FeatureTogglingRender
                notAllowedProductKey={MORNINGSTAR_MOST_POPULAR}
                productKeyFilter="some"
              >
                <div className="col-md-12 grid-view--fix-cell-separation">
                  <BrokerMostPopularOfMonth
                    defaultTab={this.defaultTab(flagBasedFeatures)}
                    deactivateTabsMode={this.deactivateTabsMode(flagBasedFeatures)}
                    disclaimerPlans
                    titleKey="broker-mostPopularOfMonthTitlePG"
                    toolTipContentKey="mostPopularOfMonth-mostPopularOfMonthTooltipPG"
                    pageName={PROC_INVESTMENT_BROKER_PG_NAME}
                  />
                </div>
              </FeatureTogglingRender>
              <div className="col-md-12 grid-view--fix-cell-separation">
                {knowTheseStocksRedirectSection}
              </div>
              {watchlistEnabled && newsSourceTextElement}
            </div>
          </div>
          <div className="col-xs-12 col-md-4">
            <div className="row">{watchlistEnabled && investmentSpecialistAndOthers}</div>
            {!brokerIAEnabled && (
              <div className="broker-general-view__side-ad">
                <CommercialAds path="broker/general" type="banner-a" />
              </div>
            )}
            <FeatureTogglingRender
              productKeyFilter="every"
              notAllowedProductKey={[TREND, TYPE_STOCKS]}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                  <BrokerMarketsTrend
                    onHandleBuyClick={(nextLink, productName) => {
                      taggingEventHandled(
                        PROC_INVESTMENT_BROKER_PG_NAME,
                        'trendsCardBuy',
                        productName
                      );
                      this.handleStockContractClick(nextLink);
                    }}
                    pageName={PROC_INVESTMENT_BROKER_PG_NAME}
                  />
                </div>
              </div>
            </FeatureTogglingRender>
            {brokerIAEnabled && (
              <FeatureTogglingRender notAllowedProductKey={ALERTS}>
                <div className="row">
                  <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                    <BrokerAlerts
                      brokerAlerts={brokerAlerts}
                      getAlerts={this.props.getAlerts}
                      onClickAlertsTooltip={() =>
                        taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'alertsTooltip')
                      }
                    />
                  </div>
                </div>
              </FeatureTogglingRender>
            )}
          </div>
        </div>
        <div className="row grid-view--fix-cell-separation">
          <FeatureTogglingRender notAllowedProductKey={NEWS}>
            <div className="col-xs-8 grid-view--fix-cell-separation">
              <BrokerNewsColumn
                immBrokerNews={this.props.immBrokerNews}
                requestNews={this.props.requestNews}
                maxNews={2}
                width="col-lg-6"
                newsSection={false}
                pageName={PROC_INVESTMENT_BROKER_PG_NAME}
              />
            </div>
          </FeatureTogglingRender>
          <FeatureTogglingRender notAllowedProductKey={AGENDA}>
            <div className="col-xs-4 grid-view--fix-cell-separation">
              <BrokerMarketsCalendar
                immBrokerMarketsCalendar={this.props.immBrokerMarketsCalendar}
                section="general"
                pageName={PROC_INVESTMENT_BROKER_PG_NAME}
              />
            </div>
          </FeatureTogglingRender>
        </div>
        <FeatureTogglingRender notAllowedProductKey={AGENDA && NEWS}>
          <div className="row">{!watchlistEnabled && newsSourceTextElement}</div>
        </FeatureTogglingRender>
      </div>
    );
  }

  buildTutorial() {
    const notCenterPadding = screen.width <= TABLET_PRO_MIN_WIDTH;
    return (
      <TutorialLauncher
        type={GRAPHIC_TUTOR_TYPE_7}
        title={formatText('tutorials-brokerCarteraLandingTitle')}
        subtitle={formatText('tutorials-brokerCarteraLandingSubtitle')}
        tooltip={formatText('tutorials-brokerCWLandingTooltip')}
        notCenterPadding={notCenterPadding}
        onOpenHandler={this.handleTutorialClick}
      />
    );
  }

  buildHeader(totalPlans) {
    const {
      immMyWalletCharts,
      onOpenTraderClick,
      onStartConvenienceMiFIDTest,
      immBrokerUsPersonBlock,
    } = this.props;
    const tutorial = this.buildTutorial();
    const isUsPerson = immBrokerUsPersonBlock.get('isUsPerson');
    const immBrokerMyInvestments = this.getBrokerMyInvestments();
    const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const buySellBtnText = formatText('broker-buySellBtnText');
    const disclaimerText = formatText('broker-disclaimerText');

    const viewTitle = (
      <div className="broker-general-view__header-legacy-title">
        <FormattedText value="broker-globalPositionHeaderTitle" />
      </div>
    );
    const moreOptions = (
      <BrokerGeneralMoreOptionsButton
        onStartConvenienceMiFIDTest={onStartConvenienceMiFIDTest}
        funds={immFunds}
        plans={totalPlans}
        onOpenTraderClick={onOpenTraderClick}
        onHandleStockContractClick={this.handleStockContractClick}
        isUsPerson={isUsPerson}
        openModal={() => this.setState({ openModalUsPerson: true })}
      />
    );
    const actionLinkButton = (
      <OKButton modifier="primary" to={MYPROFILE_BROKER_EXPLORE_URL}>
        {buySellBtnText}
      </OKButton>
    );

    const actualValue = formatWithoutRound(immMyWalletCharts.getIn(['totalValue', 'amount']), 2);
    const actualValueCurrency = formatCurrency(immMyWalletCharts.getIn(['totalValue', 'currency']));
    const actualValueFormatted = `${actualValue} ${actualValueCurrency}`;

    const tooltip = <OKTooltip content="broker-legacyHeaderTotalTooltip" offset={[0, -15]} />;

    const cover = (
      <RAOKCover size="higher-small" section="broker" customClass="col-xs-12">
        <OKHeaderLanding
          title={viewTitle}
          inputClassName="broker-general-view__header-legacy-landing"
          tutorial={tutorial}
        >
          <div className="broker-general-view__header-legacy-container">
            <div className="broker-general-view__header-box-container">
              <div className="broker-general-view__header-legacy-right-content">
                <div className="broker-general-view__header-legacy-label">
                  <FormattedText value="broker-brokerTotalOperations" />
                  <div>{tooltip}</div>
                </div>
                <div className="broker-general-view__header-legacy-amount">
                  {actualValueFormatted}
                </div>
              </div>
            </div>
            <div className="broker-general-view__header-legacy-buttons">
              {moreOptions}
              {actionLinkButton}
            </div>
          </div>
        </OKHeaderLanding>
      </RAOKCover>
    );

    return (
      <div className="container-fluid broker-general-view--header-identifier">
        <div className="row">{cover}</div>
        <div className="row broker-general-view__banner-container">
          <StocksBanner />
        </div>
        <div className="row broker-general-view__disclaimer">
          {disclaimerText}
          <OKLink
            extraClass="broker-general-view__ra-disclaimer"
            onClick={() => this.builTickerdModal()}
          >
            {formatText('broker-moreInfo')}
          </OKLink>
        </div>
        <div className="broker-general-view__separation"></div>
      </div>
    );
  }

  buildRoboHeader() {
    const {
      immRAGlobalPosition,
      match: {
        params: { robo },
      },
      flagBasedFeatures,
      immMyWalletCharts,
    } = this.props;
    const tutorial = this.buildTutorial();

    const discretionaryAccountAmount = {
      amount: immRAGlobalPosition.getIn(['patrimony', 'discretional', 'amount']),
      currency: EURO_TEXT,
    };
    const ownAccountAmount = {
      amount: discretionaryAccountAmount.amount
        ? immRAGlobalPosition.getIn(['patrimony', 'own', 'amount'])
        : immMyWalletCharts.getIn(['totalValue', 'amount']),
      currency: EURO_TEXT,
    };
    const ownAccountPercent = immRAGlobalPosition.getIn(['patrimony', 'own', 'percentage']);
    const discretionaryAccountPercent = immRAGlobalPosition.getIn([
      'patrimony',
      'discretional',
      'percentage',
    ]);
    const secondTabMessageTranslation = 'broker-globalPositionHeaderTabRightMessage';
    const disclaimerText = formatText('broker-disclaimerText');
    const isRoboActive = !!robo;

    const headerLeftTabClassName = classNames('broker-general-view__header-tab', {
      'broker-general-view__header-tab--active': !isRoboActive,
      'broker-general-view__header-tab--left': isRoboActive,
    });
    const headerRightTabClassName = classNames(
      'broker-general-view__header-tab broker-general-view__header-tab--right',
      {
        'broker-general-view__header-tab--active': isRoboActive,
      }
    );
    const headerLeftTabText = classNames('broker-general-view__header-tab-text', {
      'broker-general-view__header-tab-text--active': !isRoboActive,
    });
    const headerRightTabText = classNames('broker-general-view__header-tab-text', {
      'broker-general-view__header-tab-text--active': isRoboActive,
    });

    const viewTitle = (
      <div className="broker-general-view__header-title">
        <FormattedText value="broker-globalPositionHeaderTitle" />
      </div>
    );
    const coverSize = flagBasedFeatures.get(YOUR_INVESTMENTS) ? 'large' : 'small';
    const cover = (
      <RAOKCover size={coverSize} section="broker" customClass="col-xs-12">
        <OKHeaderLanding
          title={viewTitle}
          inputClassName="broker-general-view__header-landing"
          tutorial={tutorial}
        >
          <div className="broker-general-view__header-box-container">
            <RAPatrimonyDetails
              ownAccountAmount={ownAccountAmount}
              discretionaryAccountAmount={discretionaryAccountAmount}
              ownAccountPercent={ownAccountPercent}
              discretionaryAccountPercent={discretionaryAccountPercent}
              onClickHandler={this.handlePatrimonyDetailsClick}
            />
          </div>
        </OKHeaderLanding>
        <FeatureTogglingRender notAllowedProductKey={YOUR_INVESTMENTS}>
          <div className="broker-general-view__header-tabs">
            <div className={headerLeftTabClassName} onClick={this.handleBrokerTabClick}>
              <OKButton modifier="link-ghost">
                <FormattedText
                  className={headerLeftTabText}
                  value="broker-broker_globalPositionHeaderTab1"
                />
              </OKButton>
            </div>
            <div className={headerRightTabClassName} onClick={this.handleRoboTabClick}>
              <OKButton modifier="link-ghost">
                <FormattedText
                  className={headerRightTabText}
                  value="broker-broker_globalPositionHeaderTab2"
                />
                <FormattedText
                  className="broker-general-view__header-tab-right-content"
                  format="uppercase"
                  value={secondTabMessageTranslation}
                />
              </OKButton>
            </div>
          </div>
        </FeatureTogglingRender>
      </RAOKCover>
    );

    return (
      <div className="container-fluid broker-general-view--header-identifier">
        <div className="row broker-general-view__banner-container">
          <StocksBanner />
          <div className="row broker-general-view__ra-disclaimer">
            {disclaimerText}
            <OKLink
              extraClass="broker-general-view__ra-disclaimer"
              onClick={() => this.builTickerdModal()}
            >
              {formatText('broker-moreInfo')}
            </OKLink>
          </div>
        </div>
        <div className="row">{cover}</div>
        <div className="broker-general-view__separation"></div>
      </div>
    );
  }

  builTickerdModal() {
    const { immBrokerExchangeIndexes } = this.props;
    const { showTickerModal } = this.state;
    const indexes = immBrokerExchangeIndexes.get('indexes');
    this.setState({ showTickerModal: true });
    if (showTickerModal) {
      const modalContent = (
        <React.Fragment>
          <div>
            <FormattedText value="broker-tickerModalSubtitle"></FormattedText>
          </div>
          <div>
            <ul className="broker-general-view__modal-list">
              {indexes.map((index, i) => {
                if (i <= 5) {
                  const tickerItemtText = `broker-tickerModalItem${i + 1}`;
                  return (
                    <li key={index} className="broker-general-view__modal-list-item">
                      <FormattedText value={tickerItemtText}></FormattedText>
                    </li>
                  );
                } else return null;
              })}
            </ul>
          </div>
          <div>
            <FormattedText value="broker-tickerModalSource"></FormattedText>
          </div>
        </React.Fragment>
      );

      return (
        <OKModal
          content={modalContent}
          footerType="navigation"
          isOpen={true}
          onCloseCallback={() => this.setState({ showTickerModal: false })}
          onPrimaryButtonClick={() => this.setState({ showTickerModal: false })}
          primaryButtonText="raNonresidentialModal-button"
          title="broker-tickerModalTitle"
        />
      );
    }
  }

  buildFeatureModal() {
    const { immRAFeatureFlag, featureModalToggle } = this.props;
    return (
      <RAFeatureFlagModal
        immRAFeatureFlag={immRAFeatureFlag}
        featureModalToggle={featureModalToggle}
      />
    );
  }

  onHandleToggleModal = () => {
    this.setState({
      showNonResidentModalForOpenSecurities: false,
    });
  };

  buildNonResidentModal(openSecurityModal) {
    const { immProfile, immVariables } = this.props;
    const { showNonResidentModalForOpenSecurities, showNonResidentModal } = this.state;
    const residency = immProfile.get('paisResidencia').toLowerCase();
    let showModal, title, closeModal, message, number;

    if (openSecurityModal) {
      showModal = showNonResidentModalForOpenSecurities;
      title = formatText('broker-titleHireSecurityAccountMissingDNIError');
      closeModal = this.onHandleToggleModal;
      message = formatText(`broker-hireSecurityAccountMissingDNIErrorMessage_${residency}`);
      number = immVariables.getIn(['telefono', 'inversiones']);
    } else {
      showModal = showNonResidentModal;
      title = formatText('raNonresidentialModal-titleNonObjective');
      closeModal = this.onHandleTogglNonResidentModal;
      message = formatText('raNonresidentialModal-description');
      number = RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER;
    }

    return (
      <RANonresidentialModal
        showModal={showModal}
        title={title}
        closeModal={closeModal}
        message={message}
        button={formatText('raNonresidentialModal-button')}
        number={number}
      />
    );
  }

  onSubmitNewList() {
    this.props.createNewListName();
  }

  onWatchlistModalToggle() {
    this.props.watchlistModalToggle(true);
  }

  cancelWatchlistModal() {
    this.props.resetWatchlistDetails();
  }

  saveListName(listName) {
    this.props.saveListName(listName);
  }

  onWatchlistDetails(listId) {
    this.props.history.push(`/myprofile/broker/watchlist/${listId}`);
  }

  handleWatchlistModal() {
    const { immFavoriteContent } = this.props;
    const watchlistContent = immFavoriteContent.get('watchlistContent');
    const isModalOpen = immFavoriteContent.get('isModalOpen');
    const listName = immFavoriteContent.get('listName');

    return (
      <BrokerWatchlistModal
        watchlistContent={watchlistContent}
        isModalOpen={isModalOpen}
        modifier={'createNewList'}
        saveListName={this.saveListName}
        listName={listName}
        handleCancelForModal={this.cancelWatchlistModal}
        handleContinueForNewList={this.onSubmitNewList}
      />
    );
  }

  handleOpenHireClick = () => {
    const {
      checkPersonalInformationData,
      flagBasedFeatures,
      history,
      immProfile,
      immbrokerClientWarningModal,
    } = this.props;

    const checkHiringCountriesNotMatchingWithOriginCountry =
      flagBasedFeatures.get(CCV_HIRING_CHECK_DOCUMENT);

    if (checkHiringCountriesNotMatchingWithOriginCountry) {
      const nationality = immProfile.get('paisNacionalidad');

      if (nationality === ES) {
        checkPersonalInformationData();
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get(
          'clientPersonalInfoUpdated'
        );
        if (!clientPersonalInfoUpdated) {
          this.setState({
            showNonResidentModalForOpenSecurities: true,
          });
        } else {
          history.push(HIRE_VALUES_CONTRACT_URL);
        }
      } else {
        history.push(HIRE_VALUES_CONTRACT_URL);
      }
    } else {
      history.push(HIRE_VALUES_CONTRACT_URL);
    }
  };

  buildInformativePopUp() {
    const {
      flagBasedFeatures,
      immBrokerInformativePopUp,
      match: {
        params: { robo },
      },
    } = this.props;
    const { showInformativePopUpModal } = this.state;

    if (!!robo) {
      const roboPopUpIsActive = immBrokerInformativePopUp.get('roboadvisorPopUp');
      return (
        <BrokerInformativePopUp
          isOpen={showInformativePopUpModal && roboPopUpIsActive}
          handleClose={this.onHandleToggleInformativePopUpModal}
          featureFlag={flagBasedFeatures.get(INFO_POPUP_ROBOADVISOR)}
          titleKey="brokerInformativePopUp-roboadvisor_title"
          contentKey="brokerInformativePopUp-roboadvisor_content"
          buttonKey="brokerInformativePopUp-roboAdvisor_understoodButton"
        />
      );
    } else {
      const youInvestPopUpIsActive = immBrokerInformativePopUp.get('youInvestPopUp');
      return (
        <BrokerInformativePopUp
          isOpen={showInformativePopUpModal && youInvestPopUpIsActive}
          handleClose={this.onHandleToggleInformativePopUpModal}
          featureFlag={flagBasedFeatures.get(INFO_POPUP_YOU_INVEST)}
          titleKey="brokerInformativePopUp-youInvest_title"
          contentKey="brokerInformativePopUp-youInvest_content"
          buttonKey="brokerInformativePopUp-youInvest_understoodButton"
        />
      );
    }
  }

  buildTestExpirationMessage() {
    return (
      <div className="broker-general-view__broker-test-expiration-message-container">
        <RATestExpirationDisclaimer />
      </div>
    );
  }

  render() {
    const {
      flagBasedFeatures,
      match: {
        params: { robo },
      },
      immPortfolioDistribution,
    } = this.props;
    const immBrokerMyInvestments = this.getBrokerMyInvestments();
    const isFetchingMyInvestment = this.isFetchingMyInvestment();
    const errorReceivedMyInvestment = this.errorReceivedMyInvestment();
    const showRobo = flagBasedFeatures.get('robo-enabled');
    const totalPlans = immBrokerMyInvestments.getIn(['products', 'plans', 'stocks']).toJS().length;
    const informativePopUp = this.buildInformativePopUp();
    const testExpirationMessage = this.buildTestExpirationMessage();
    let bodyContent, plansStartingModal;
    if (!!robo) {
      //Because on initial render 'isFetchingMyInvestement' is undefined and then 'RAGlobalPosition' is rendered unnecessary
      //We must to render it when the fetching is complete because if not the component fires a wrong tagging
      if (!isFetchingMyInvestment && !this.state.initialRender) {
        const isRoboStateError = immPortfolioDistribution.getIn(['roboAdvisor', 'withError']);
        bodyContent =
          !errorReceivedMyInvestment && !isRoboStateError ? (
            <RAGlobalPosition />
          ) : (
            this.buildRoboErrorState()
          );
        plansStartingModal = null;
      }
    } else {
      plansStartingModal = <BrokerAttentionPlanStartingModal place={BROKER_LANDING_PG_PLACE} />;
      bodyContent = this.buildBrokerBody(
        immBrokerMyInvestments,
        isFetchingMyInvestment,
        errorReceivedMyInvestment,
        totalPlans
      );
    }
    const header = showRobo ? this.buildRoboHeader(totalPlans) : this.buildHeader(totalPlans);
    const featureModal = this.buildFeatureModal();
    const tickerModal = this.state.showTickerModal ? this.builTickerdModal() : null;
    const nonResidentModal = this.state.showNonResidentModalForOpenSecurities
      ? this.buildNonResidentModal(true)
      : this.buildNonResidentModal();
    const watchlistModal = this.handleWatchlistModal();

    return (
      <React.Fragment>
        <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
        <div>
          <OKModal
            description={'us_person_popup-opentrader_message'}
            descriptionAlignment="center"
            footerType="action" //navigation
            isOpen={this.state.openModalUsPerson}
            onCloseCallback={() => this.setState({ openModalUsPerson: false })}
            onPrimaryButtonClick={() => this.setState({ openModalUsPerson: false })}
            primaryButtonText={'us_person_popup-confirm_button_title'}
            title={'us_person_popup-opentrader_title'}
            titleAlignment="center"
          />
          <div className="broker-general-view__search-widget">
            <BrokerSearchWidget />
          </div>
          <BrokerClientWarningModal
            nextLocation={this.state.nextLocation}
            productIsin={this.state.productIsin}
            orderType={this.state.orderType}
            routerHookCallback={() => {
              this.setState({ isBlockingRouteChange: false });
            }}
          />
          {plansStartingModal}
          {header}
          <div className="grid-view__body">
            {informativePopUp}
            {testExpirationMessage}
            {bodyContent}
            {featureModal}
            {nonResidentModal}
            {watchlistModal}
            {tickerModal}
          </div>
          <div className="container-fluid grid-view__cross-selling">
            <div className="row">
              <CommercialAds path="broker/general" type="cross-selling" />
            </div>
          </div>
          <BrokerNoStockAccountModal />
          <BrokerRoboExpirationMessage history={this.props.history} />
        </div>
      </React.Fragment>
    );
  }
}

BrokerGeneralView.propTypes = {
  bannerHide: PropTypes.func,
  bannerShow: PropTypes.func,
  bannerUpdateData: PropTypes.func,
  brokerAlerts: PropTypes.object,
  brokerMyInvestments: PropTypes.object,
  brokerWalletsState: PropTypes.object,
  checkPersonalInformationData: PropTypes.func,
  checkStatus: PropTypes.func,
  createNewListName: PropTypes.func,
  featureModalToggle: PropTypes.func.isRequired,
  fetchFeatureFlag: PropTypes.func.isRequired,
  flagBasedFeatures: PropTypes.object,
  flagBasedMBFeatures: PropTypes.object,
  getAlerts: PropTypes.func,
  getDefaultViewID: PropTypes.func,
  getEvolutionData: PropTypes.func,
  getIndexes: PropTypes.func,
  getMyInvestments: PropTypes.func.isRequired,
  getOtherProductsIsins: PropTypes.func,
  searchProducts: PropTypes.object,
  handleSearchProduct: PropTypes.func,
  handleSearchReset: PropTypes.func,
  moveToFromSearch: PropTypes.func,
  resetSelectedView: PropTypes.func,
  immBrokerNews: PropTypes.object,
  getStocksByType: PropTypes.func,
  getStocksByContract: PropTypes.func,
  getStocksContracts: PropTypes.func,
  getUserWatchlist: PropTypes.func.isRequired,
  getWalletData: PropTypes.func,
  handleShowSearchWidget: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  immAccounts: PropTypes.object,
  immBrokerCustomWalletInvestments: PropTypes.object,
  immBrokerCustomWalletPortfolios: PropTypes.object,
  immBrokerExchangeIndexes: PropTypes.object,
  immBrokerMarketsCalendar: PropTypes.object,
  immBrokerSimpleSearchWidget: PropTypes.object,
  immBrokerInformativePopUp: PropTypes.object,
  immFavoriteContent: PropTypes.object,
  immGlobalPosition: PropTypes.object,
  immMyWalletCharts: PropTypes.object,
  immVariables: PropTypes.object.isRequired,
  immProfile: PropTypes.object,
  immRAFeatureFlag: PropTypes.object.isRequired,
  immRAGlobalPosition: PropTypes.object,
  immStocksContracts: PropTypes.object.isRequired,
  immbrokerClientWarningModal: PropTypes.object,
  immTutorial: PropTypes.object.isRequired,
  immPortfolioDistribution: PropTypes.object.isRequired,
  onInternalTransferFundsClick: PropTypes.func.isRequired,
  onOpenTraderClick: PropTypes.func.isRequired,
  onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
  onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
  onToggleModal: PropTypes.func,
  outdateCustomWalletInvestments: PropTypes.func.isRequired,
  outdateMyInvestments: PropTypes.func.isRequired,
  match: PropTypes.object,
  postWalletAlias: PropTypes.func,
  requestNews: PropTypes.func,
  resetWatchlistDetails: PropTypes.func,
  listSelectedForParam: PropTypes.func,
  saveListName: PropTypes.func,
  setOperationContractValue: PropTypes.func.isRequired,
  setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
  setOrdersAndMovementsContract: PropTypes.func.isRequired,
  setSellContract: PropTypes.func.isRequired,
  setPreoviousPage: PropTypes.func.isRequired,
  showClientWarningModal: PropTypes.func,
  showNoStockAccountModal: PropTypes.func,
  onToggleEvolutionModal: PropTypes.func,
  toggleDerechosInfo: PropTypes.func,
  watchlistModalToggle: PropTypes.func,
  getContractState: PropTypes.func,
  getPopUpsInfo: PropTypes.func,
  immBrokerUsPersonBlock: PropTypes.object,
  getIsUsPerson: PropTypes.func,
};

module.exports.constructor = BrokerGeneralView;
module.exports.BrokerGeneralView = connect(
  state => ({
    brokerAlerts: state.brokerAlerts,
    immProfile: state.profile,
    brokerState: state.brokerState,
    immMyWalletCharts: state.myWalletCharts,
    searchProducts: state.brokerSearch,
    brokerMyInvestments: state.brokerMyInvestments,
    brokerMarketsCalendar: state.brokerMarketsCalendar,
    brokerWalletsState: state.brokerWallets,    
    immAccounts: state.accounts,
    immBrokerCustomWalletInvestments: state.brokerCustomWalletInvestments,
    immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios,
    immBrokerExchangeIndexes: state.brokerExchangeIndexes,
    immBrokerMarketsCalendar: state.brokerMarketsCalendar,
    immBrokerNews: state.brokerNews,
    immBrokerSearchWidget: state.brokerSearchWidget,
    immFavoriteContent: state.brokerWatchlist,
    immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    immRAFeatureFlag: state.raFeatureFlag,
    immRAGlobalPosition: state.raGlobalPosition,
    immStocksContracts: state.brokerStocksContract,
    immTutorial: state.tutorial,
    toggleDerechosInfo: PropTypes.func,
    immbrokerClientWarningModal: state.brokerClientWarningModal,
    immBrokerInformativePopUp: state.brokerInformativePopUp,
    immBrokerUsPersonBlock: state.brokerIsUsPerson,
    immPortfolioDistribution: state.raPortfolioDistribution,
  }),
  {
    bannerHide: bannerActions.bannerHide,
    bannerShow: bannerActions.bannerShow,
    bannerUpdateData: bannerActions.bannerUpdateData,
    checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
    checkStatus: raCheckStatusActions.checkStatus,
    createNewListName: BrokerWatchlistActions.createNewListName,
    featureModalToggle: raFeatureFlagActions.featureModalToggle,
    fetchFeatureFlag: raFeatureFlagActions.fetchFeatureFlag,
    getAlerts: BrokerAlertsActions.getAlerts,
    getDefaultViewID: myWalletAction.getDefaultViewID,
    getEvolutionData: myWalletAction.getEvolutionData,
    getIndexes: brokerTodaysMainStocksActions.getIndexes,
    getMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
    getOtherProductsIsins: brokerStocksByTypeActions.getOtherProductsIsins,
    getStocksByContract: brokerStocksByContractActions.getStocksByWallet,
    getStocksByType: brokerStocksByTypeActions.getStocksByType,
    getStocksContracts: brokerStocksByContractActions.getWalletList,
    getUserWatchlist: BrokerWatchlistActions.getUserWatchlist,
    getWalletData: BrokerCustomWalletLoaderActions.getWalletData,
    handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
    onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
    onOpenTraderClick: BrokerOpenTraderActions.openLink,
    onPreSelectOriginInternalTransferFund: BrokerInternalTransferFundsActions.preSelectOrigin,
    onToggleEvolutionModal: myWalletAction.toggleEvolutionModal,
    onInternalTransferFundsClick: BrokerInternalTransferFundsActions.setOriginFund,
    onToggleModal: myWalletAction.toggleModal,
    outdateCustomWalletInvestments: BrokerCustomWalletInvestmentsActions.outdateMyInvestments,
    outdateMyInvestments: BrokerMyInvestmentsActions.outdateMyInvestments,
    postWalletAlias: brokerStocksByContractActions.postWalletAlias,
    getContractState: brokerContractState.getContractState,
    setPreoviousPage: brokerTodaysMainStocksActions.setPreoviousPage,
    requestNews: newsActions.requestNews,
    resetSelectedView: myWalletAction.resetSelectedView,
    resetWatchlistDetails: BrokerWatchlistActions.resetWatchlistDetails,
    listSelectedForParam: BrokerWatchlistActions.listSelectedForParam,
    saveListName: BrokerWatchlistActions.saveListName,
    setOperationContractValue: BrokerCorporatesOperations.changeStocksContractValue,
    setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
    setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
    setSellContract: BrokerStocksSellActions.setSellContract,
    showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
    showNoStockAccountModal: brokerNoStockAccountModalActions.showModal,
    toggleDerechosInfo: BrokerMyInvestmentsActions.toggleDerechosInfoMessage,
    watchlistModalToggle: BrokerWatchlistActions.watchlistModalToggle,
    getPopUpsInfo: BrokerInformativePopUpActions.getPopUpsInfo,
    getIsUsPerson: BrokerUsPersonBlockActions.getIsUsPersonInfo,
  }
)(withFeatureToggling(withRouter(BrokerGeneralView)));
